import { useState, useEffect, useRef } from 'react';

export const useHover = (): [boolean, React.RefObject<HTMLDivElement>] => {
  const [isHovering, setIsHovering] = useState(false);
  const hoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseOver = (): void => setIsHovering(true);
    const handleMouseOut = (): void => setIsHovering(false);
    const ref = hoverRef.current;

    if (ref) {
      ref.addEventListener('mouseover', handleMouseOver);
      ref.addEventListener('mouseout', handleMouseOut);

      return () => {
        ref.removeEventListener('mouseover', handleMouseOver);
        ref.removeEventListener('mouseout', handleMouseOut);
      };
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hoverRef.current]);

  return [isHovering, hoverRef];
};
